import { useEffect, useRef } from "react";

/**
 * Runs a sub-panel's own field validation when the parent asks it to — used when a failed "Next Step"
 * jumps the user into an incomplete Trip Details sub-panel, so its inline errors show immediately
 * (not just the danger row). Fires on mount when `forceValidate` is already true (the jump case) and
 * again whenever it flips true while mounted (re-pressing Next Step on the already-open panel).
 *
 * `validate` is kept in a ref so callers can pass an inline closure without retriggering on every
 * render — only the `forceValidate` signal drives it.
 */
export const useForceValidate = (forceValidate: boolean, validate: () => void) => {
  const validateRef = useRef(validate);
  validateRef.current = validate;
  useEffect(() => {
    if (forceValidate) validateRef.current();
  }, [forceValidate]);
};
